import {MenuItem,} from '@mui/material';
import { Box } from '@mui/system';
import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import DivContainerBody from "../../../../../components/DivContainerBody";
import {CustomSelectAndChildren} from "../../../../../components/CustomSelectAndChildren";
import {CustomTextField} from "../../../../../components/CustomTextField";
import {CustomDatePicker} from "../../../../../components/CustomDatePicker";
import {CustomCheckbox} from "../../../../../components/CustomCheckbox";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {AddIcon, CleanIcon} from "../../../../../components/buttons/IconButtons";
import {EmployeeFlowCreateOrderApp} from "../../../Supplier/Funtionality/SupplierCreateUpdateFlows/EmployeeFlowCreateOrderApp";
import ButtonIcon from "../../../../../components/buttons/ButtonIcon";
import React from "react";

export const EmployeeFlowCreateOrder = () => {

    const {
        CreateOrderHandler,
        handleClear,
        order,
        getEmployeeProviderLists,
        emptyFields,
        handleChange
    } = EmployeeFlowCreateOrderApp()

    return (
        <>
            <HeadTittle
                name={'order'}
                onBack={routes.suppliers.main}
                divStack={
                    <div className={"ml-1"}>
                        <ButtonIcon
                            id='btn_efc_clean'
                            Icon={CleanIcon}
                            onClick={handleClear}
                            title={'clear_instances'}
                            className={"btn-clean-secondary-600"}
                            tooltipPlacement={"right"}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    </div>
                }
            >
                <ButtonAction
                    id='btn_cts_create'
                    name='create'
                    className='btn-icon-add mr-2'
                    Icon={AddIcon}
                    onClick={CreateOrderHandler}
                />
            </HeadTittle>
            <DivContainerBody>
                <div className={"row mt-3"}>
                    <Box className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                        <CustomSelectAndChildren
                            id="slt_efc_choose_a_supplier"
                            name="supplierId"
                            emptyFields={emptyFields}
                            value={order.supplierId}
                            onChange={handleChange}
                            trans="choose_a_supplier"
                            label="lbl_cud_zone"
                            showNoSelectionOption={false}
                            required={true}
                        >
                            {getEmployeeProviderLists?.map((item, index) => {
                                return <MenuItem value={item.id}>{item.acronym}</MenuItem>;
                            })}
                        </CustomSelectAndChildren>
                    </Box>
                    <Box className="col-sm-12 col-md-6 col-xxl-6 col-lg-6">
                        <CustomTextField id={"slt_efc_folio"}
                                         name={"folio"}
                                         value={order.folio}
                                         trans={"folio"}
                                         onChange={handleChange}
                                         length={128}
                        />
                    </Box>
                    <Box className="col-sm-12 col-md-6 col-xxl-6 col-lg-6">
                        <CustomDatePicker
                            id='dtp_efc_delivery_date'
                            name={'deliveryDate'}
                            trans={'delivery_date'}
                            value={order.deliveryDate}
                            openTo={'day'}
                            onChange={(e) => {
                                handleChange({ target: { value: e, name: 'deliveryDate' } });
                            }}
                            emptyFields={emptyFields}
                            required={true}
                            disablePast
                        />
                    </Box>
                    <Box className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                        <CustomCheckbox
                            id="cb_efc_is_delivery"
                            checked={order.isDelivery}
                            onChange={handleChange}
                            labelId="lbl_efc_is_delivery"
                            label="is_delivery"
                            trans="is_delivery"
                            name="isDelivery"
                        />
                    </Box>
                    <Box className="col-sm-12 col-md-12 col-xxl-12 col-lg-12">
                        <CustomTextField id={"slt_efc_item"}
                                         name={"item"}
                                         value={order.item}
                                         trans={"item"}
                                         onChange={handleChange}
                                         emptyFields={emptyFields}
                                         required={true}
                                         length={128}
                        />
                    </Box>
                    <Box className="col-sm-12 col-md-12 col-xxl-12 col-lg-12">
                        <CustomTextField id={"slt_efc_description"}
                                         name={"description"}
                                         value={order.description}
                                         trans={"description"}
                                         onChange={handleChange}
                                         length={512}
                                         multiline
                                         rows={4}
                        />
                    </Box>
                </div>
            </DivContainerBody>
        </>
    );
};
